import axios from "axios";

// Crawler-safety fetch (2026-10-11 noindex incident: 3,151 live product pages
// deindexed because any API hiccup rendered "Piece Not Found" + noindex).
// Callers may only conclude "not found" when the API answers HTTP 404.
// Timeouts, 5xx, 429s and network drops during deploys are transient — retried
// with backoff, then surfaced as a recoverable error, never as "not found".
const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export const isNotFound = (err) => err?.response?.status === 404;

export async function fetchWithRetry(url, { params, attempts = 3, baseDelayMs = 700 } = {}) {
  let lastErr;
  for (let attempt = 0; attempt < attempts; attempt += 1) {
    try {
      return await axios.get(url, { params, timeout: 20000 });
    } catch (err) {
      const status = err?.response?.status;
      // A definitive client answer (400/401/403/404…) is not retried — except 429.
      if (status && status < 500 && status !== 429) throw err;
      lastErr = err;
      if (attempt < attempts - 1) await sleep(baseDelayMs * 2 ** attempt);
    }
  }
  throw lastErr;
}
